import { memo, useCallback } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { TenantsSearchFilterProps } from "./types";

import { useTranslate } from "helpers";
import { initialTenantSearchForm } from "services/api/tenants/consts";

const TenantsSearchFilters: React.FC<TenantsSearchFilterProps> = (props) => {
  const { formValues, onSearchChange } = props;
  const { t } = useTranslate();

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialTenantSearchForm);
  }, [onSearchChange]);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(TenantsSearchFilters);
